import { Injectable } from '@angular/core';
import { Modules, StorageKeys } from '@shared/constants/commons';

/**
 * Selected module persisted in localStorage (`module-selected`). Port of the module helpers of
 * legacy UtilService.
 */
@Injectable({ providedIn: 'root' })
export class ModuleSelectionStore {
  setModule(module: Modules): void {
    localStorage.setItem(StorageKeys.MODULE_SELECTED, module);
  }

  /** Clears the selected module and the kiosk/queue/timer keys, like legacy clearModule(). */
  clearModule(): void {
    localStorage.removeItem(StorageKeys.MODULE_SELECTED);
    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith('queue_manager_') || key.startsWith('withdraw_') || key.startsWith('timer')) {
        localStorage.removeItem(key);
      }
    });
  }

  getCurrentModule(): Modules | null {
    const module = localStorage.getItem(StorageKeys.MODULE_SELECTED);
    return module ? (module as Modules) : null;
  }
}
